import { stringify } from "query-string"
import { apiInstance } from "./api"

const endpoint = "/order"

export const getPaidOrders = async queries => {
  const { dhFoods } = apiInstance()

  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await dhFoods.get(`${endpoint}/kitchen?${query}`)

  return response.data
}

export const getOrderHistory = async queries => {
  const { dhFoods } = apiInstance()

  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoods.get(`${endpoint}/history?${query}`)

  return response.data
}

export const assignRiderToOrder = async (orderId, data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/kitchen/${orderId}/assignRider`, data)

  return response.data
}

export const getOrders = async queries => {
  const { dhFoods } = apiInstance()

  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await dhFoods.get(`${endpoint}?${query}`)

  return response.data
}

export const getKitchenOrders = async queries => {
  const { dhFoods } = apiInstance()

  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await dhFoods.get(`${endpoint}/kitchen?${query}`)

  return response.data
}

export const changeOrderStatusToDelivered = async (orderId) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/status/${orderId}/delivered`)

  return response.data
}

export const sendOrder = async (data, queries) => {
  const { dhFoods } = apiInstance()

  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoods.post(`${endpoint}?${query}`, data)

  return response.data
}

export const getOrder = async (orderId, bypassIsViewed = false) => {
  const { dhFoods } = apiInstance()

  const query = stringify({
    bypassIsViewed
  }, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await dhFoods.get(`${endpoint}/${orderId}?${query}`)

  return response.data
}
export const getSalesReport = async (queries) => {
  const { dhFoods } = apiInstance()

  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await dhFoods.get(`${endpoint}/report/sale?${query}`)

  return response.data
}

export const getStatisticReport = async (queries) => {
  const { dhFoods } = apiInstance()

  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await dhFoods.get(`${endpoint}/report/statistic?${query}`)

  return response.data
}

export const getFoodsReport = async (queries) => {
  const { dhFoods } = apiInstance()

  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await dhFoods.get(`${endpoint}/report/food?${query}`)

  return response.data
}

export const getFoodCostReport = async (queries) => {
  const { dhFoods } = apiInstance()

  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await dhFoods.get(`${endpoint}/report/food/cost?${query}`)

  return response.data
}

export const getShareholdersReport = async (queries) => {
  const { dhFoods } = apiInstance()

  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await dhFoods.get(`${endpoint}/report/shareholder?${query}`)

  return response.data
}

export const getReferralReport = async (queries) => {
  const { dhFoods } = apiInstance()

  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoods.get(`${endpoint}/report/referral?${query}`)

  return response.data
}

export const deleteOrder = async (orderId, queries) => {
  const { dhFoods } = apiInstance()

  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoods.delete(`${endpoint}/${orderId}?${query}`)

  return response.data
}

export const editOrderAddress = async (orderId, data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/address/${orderId}`, data)

  return response.data
}

export const cancelOrder = async (orderId, data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.post(`${endpoint}/cancel/${orderId}`, data)

  return response.data
}

export const runOrderPrinter = async queries => {
  const { dhFoods } = apiInstance()

  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await dhFoods.post(`${endpoint}/print/run?${query}`)

  return response.data
}

export const validateCouponForOrders = async (data, queries) => {
  const { dhFoods } = apiInstance()

  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await dhFoods.post(`${endpoint}/couponCheckValidation/group?${query}`, data)

  return response.data
}

export const validateCouponForOrder = async (data, queries) => {
  const { dhFoods } = apiInstance()

  const query = stringify(queries, {
    skipEmptyString: true,
    skipNull: true
  })

  const response = await dhFoods.post(`${endpoint}/couponCheckValidation?${query}`, data)

  return response.data
}

export const cancelOrderQuotation = async quotationId => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.post(`${endpoint}/service/cancel/${quotationId}`)

  return response.data
}

export const getSnapboxQuotation = async (data, queries) => {
  const { dhFoods } = apiInstance()

  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoods.post(`${endpoint}/service/quotation?${query}`, data)

  return response.data
}

export const getNotViewedOrders = async (queries) => {
  const { dhFoods } = apiInstance()

  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await dhFoods.get(`${endpoint}/unread/count?${query}`)

  return response.data
}

export const setOrdersAsViewed = async (data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.post(`${endpoint}/unread/readall`, data)

  return response.data
}

export const combineOrders = async (data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.post(`${endpoint}/combine/multiple`, data)

  return response.data
}

export const editOrder = async (orderId, data, queries) => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/${orderId}?${query}`, data)

  return response.data
}

export const editOrderPaymentDetails = async (orderId, data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/paymentDetails/${orderId}`, data)

  return response.data
}

export const editOrderTableNumber = async (orderId, tableNumber) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/tableNumber/${orderId}`, { tableNumber })

  return response.data
}

export const changePaymentProblematicStatus = async (orderId, data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/paymentProblematicStatus/${orderId}`, data)

  return response.data
}

export const getOrderByCode = async (orderCode) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.get(`${endpoint}/getByCode/${orderCode}`)

  return response.data
}

export const orderDispatched = async (orderId) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.post(`${endpoint}/dispatched/${orderId}`)

  return response.data
}

export const confirmOrder = async (orderId) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.patch(`${endpoint}/confirm/${orderId}`)

  return response.data
}

export const setOrderIsReady = async (orderId, data) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.post(`${endpoint}/ready/${orderId}`, data)

  return response.data
}

export const setOrderIsLate = async (orderId) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.post(`${endpoint}/late/${orderId}`)

  return response.data
}

export const sendOrderIsReadySms = async (orderId) => {
  const { dhFoods } = apiInstance()

  const response = await dhFoods.post(`${endpoint}/sms/ready/${orderId}`)

  return response.data
}